module.exports = "/shifts/components/calendarStatsComponent-efa313.html";